import { render, staticRenderFns } from "./BaseFrontOfficeDivider.vue?vue&type=template&id=ab2db21e&scoped=true"
import script from "./BaseFrontOfficeDivider.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeDivider.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeDivider.vue?vue&type=style&index=0&id=ab2db21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2db21e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
